// extracted by mini-css-extract-plugin
module.exports = {"dzjmrqm":"dzjmrqm","fadein-dzjmrqm":"fadein-dzjmrqm","p1vl4use":"p1vl4use"};